module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.opened) ? _c('div', {
    staticClass: "lumi-modal"
  }, [_c('section', {
    class: _vm.className,
    on: {
      "click": _vm.closeBackdrop
    }
  }, [_c('div', {
    staticClass: "lumi-modal-inner"
  }, [_c('h2', {
    staticClass: "lumi-modal-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "lumi-modal-buttons"
  }, [_vm._t("buttons")], 2)], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7256f84f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LumiModal.vue
// module id = 65
// module chunks = 0